// TKP-153 / tunesoft2 s.1 — "Periyodik Güncelleme" yan menüde ayrı ekran (bugüne kadar Onay sekmesinin içindeydi).
// Sayfa modül düzeninin (layout) korumasından geçer; menü bağlantısı yetkili rollere (helpers/capabilities.js) görünür,
// içeriği backend zaten role göre kısıtlar (onay yetkilisi tümü, Birim/Süreç Yöneticisi kendi kapsamı).
export const kvkk = {
  routes: [{ path: "/kvkk/periodic-update", component: () => import("../periodic-update-view"), meta: { rules: [], product: "KVKK" } }],
};

export const gdpr = {
  routes: [{ path: "/gdpr/periodic-update", component: () => import("../periodic-update-view"), meta: { rules: [], product: "GDPR" } }],
};
